// library imports
import { Card, Segmented } from "antd";
import { useState } from "react";
// component imports
import ActivePvCondition from "../../components/pv_condition/ActivePvCondition";
import HistoricalPvCondition from "../../components/pv_condition/HistoricalPvCondition";

function PvConditionPage() {
  const pvConditionOptions = [
    { label: "Active", value: "active" },
    { label: "History", value: "history" },
  ];

  const [pvConditionSelection, setPvConditionSelection] = useState(
    pvConditionOptions[0].value
  );

  const contentList = {
    active: <ActivePvCondition />,
    history: <HistoricalPvCondition />,
  };

  return (
    <Card
      size="small"
      style={{
        marginLeft: "10px",
        marginRight: "10px",
        height: "100%",
      }}
      title={
        <Segmented
          size="large"
          options={pvConditionOptions}
          onChange={(value) => {
            setPvConditionSelection(value);
          }}
          value={pvConditionSelection}
        />
      }
    >
      {contentList[pvConditionSelection]}
    </Card>
  );
}

export default PvConditionPage;
